const styles = (theme) => ({
  empty: {
    fontSize: 16,
    padding: theme.spacing(3, 0),
    color: theme.color.red_00,
  },

  header: {
    height: 150,
  },

  tabs: {
    '& .MuiTabs-root': {
      top: 102,
    },
  },

  tabsWithMinimizedCall: {
    '& .MuiTabs-root': {
      top: 162,
    },
  },

  tabsWithMinimizedCallInClients: {
    '& .MuiTabs-root': {
      top: 117,
    },
  },

  scrollArea: {
    height: 'calc(100% - 150px)',
  },

  loader: {
    display: 'block',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  loadMore: {
    margin: theme.spacing(2, 0),
  },

  list: {
    padding: theme.spacing(1.25, 0),
  },

  item: {
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 0.16,
    textTransform: 'capitalize',
    padding: theme.spacing(2.5),
    cursor: 'pointer',
    transition: 'color .3s',

    '&:hover': {
      color: theme.color.teal,
    },
  },
  title: {
    width: '100%',
    height: '1em',
    fontSize: 20,
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flex: 1,
    minWidth: 0,
    padding: theme.spacing(0, 0, 5, 0),
    '& div': {
      display: 'inline',
    },
  },
  searchLabel: {
    textTransform: 'capitalize',
    color: 'rgba(0, 0, 0, 0.7)',
    fontSize: 16,
  },
  icon: {
    marginRight: theme.spacing(0.5),
    svg: {
      fill: theme.color.black,
    },
  },
  selectActionIcon: {
    width: 20,
    height: 20,
    cursor: 'pointer',
    fill: theme.color.black,
  },

  btnSelect: {
    fontSize: 16,
    lineHeight: 1.2,
    textTransform: 'capitalize',
    borderWidth: '0 0 0 1px',
    borderColor: theme.color.grey_medium,
    borderRadius: 0,
    height: 'auto',
    minWidth: 'auto',
    maxWidth: '80px',
    padding: theme.spacing(0, 0, 0, 2.5),
    transition: 'color .3s',

    '& .MuiButton-endIcon': {
      margin: 0,
    },

    '& svg': {
      transition: 'fill .3s',
      fill: theme.color.grey_dark,
    },

    '&:hover': {
      borderColor: theme.color.grey_medium,
      color: theme.color.black,

      '& svg': {
        fill: theme.color.grey_dark,
      },
    },
  },
});

export default styles;
